module.exports = __webpack_public_path__ + "media/images/countryrect/lk-6019572cc74709b7c4687580b2246838.svg";